import { render, staticRenderFns } from "./ElectricityProblemReport.vue?vue&type=template&id=418b531d&"
import script from "./ElectricityProblemReport.vue?vue&type=script&lang=js&"
export * from "./ElectricityProblemReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports